// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__20m7B","logo":"styles_logo__IneS4"};